/**
 * !!!!!!!! DO NOT MODIFY THIS FILE BY HAND !!!!!!!!
 * This file was automatically generated, and any changes made here will be overwritten.
 * @plugins/heft-rendering-pages-generator is used to generate this file from the various
 * @modules/*-rendering-page packages
 */
import { render as renderClientModule } from '@modules/channelizer-rendering-page/chip/client';
import { initClientPage, decompressIslands } from '@renderer/common/client';
import { type PageContext } from '@renderer/core';

import '@modules/channelizer-rendering-page/chip/style.css';

initClientPage();

function onRenderClient(pageContext: PageContext): void {
  decompressIslands(pageContext);

  // the user initialization code
  renderClientModule(pageContext);
}

export { onRenderClient };
